/**
 * aPure Insight Widget
 * AI-powered practice insight card with CTA.
 * Moved from StudentDashboardBeta (Phase 3.2 extraction).
 */

import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Sparkles } from 'lucide-react'

export interface ApureInsightWidgetProps {
  actionLabel: string
  text: string
  className?: string
}

const ApureInsightWidget: React.FC<ApureInsightWidgetProps> = ({
  actionLabel,
  text,
  className = '',
}) => {
  const navigate = useNavigate()

  return (
    <div
      onClick={() => navigate('/apure')}
      className={`bg-white border border-[var(--color-border-light)] rounded-[var(--radius-r)]
                  p-[18px] shadow-[var(--shadow-sh0)]
                  transition-all duration-[.2s]
                  cursor-pointer hover:shadow-[var(--shadow-sh2)] hover:-translate-y-[2px]
                  active:translate-y-0 active:scale-[.99]
                  flex flex-col ${className}`}
      style={{ borderTop: '3px solid var(--color-cyan)' }}
    >
      <div className="flex items-center gap-[7px] text-[11px] font-semibold text-[var(--color-text-tertiary)]
                      uppercase tracking-[.5px] mb-[12px]">
        <Sparkles size={13} />
        aPure Insight
        <button
          onClick={(e) => { e.stopPropagation(); navigate('/apure') }}
          className="ml-auto text-[10px] text-[var(--color-text-tertiary)] font-medium
                     hover:text-[var(--color-teal)] transition-colors duration-[.15s]"
        >
          Open AI →
        </button>
      </div>
      <div className="text-[13px] font-bold mb-[6px]" style={{ color: 'var(--color-teal)' }}>
        {actionLabel}
      </div>
      <div className="text-[12px] text-[var(--color-text-secondary)] leading-[1.5]">
        {text}
      </div>
    </div>
  )
}

export default ApureInsightWidget
